import { ButtonGroup, Flex, Link } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "@wayflyer/undercarriage";
import { useSpaNavigate } from "shared-ui";

import { useFundingApplication } from "../../queries/funding-application/queries";
import { COMMON_MESSAGES } from "../common-messages";
import { CONNECT_APP_ROUTE_PATHS } from "../constants";

import { MESSAGES } from "./message-definitions";
import { BusinessModelGeoLetDown, GeographyLetDown } from "./reasons";

export const EligibilityLetDown = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { navigate } = useSpaNavigate("FundingApp");
  const { data, isFetchedAfterMount } = useFundingApplication(customerDomain);

  const linkText = intl.formatMessage(MESSAGES.letDownLinkToEligibilityCriteriaAnchor);
  const eligbilityCriteriaMessage = intl.formatMessage(MESSAGES.letDownLinkToEligibilityCriteriaMsg, {
    link: <Link url="https://help-center.wayflyer.com/en/collections/151332-applying-for-funding">{linkText}</Link>,
  });
  const isMultiSelectBusinessModelFlow = Boolean(
    data.reportedCustomerSegment && data.reportedProductOffering && data.reportedSalesChannel
  );

  const getBackPath = () => {
    if (!data.ineligibleReason) {
      return undefined;
    }
    return {
      geography: undefined,
      business_model_geo: CONNECT_APP_ROUTE_PATHS.BUSINESS_MODEL,
    }[data.ineligibleReason];
  };

  const backPath = getBackPath();

  return isFetchedAfterMount && data ? (
    <Flex direction="column" gap="4" data-testid="ineligible-screen">
      {data.ineligibleReason
        ? {
            geography: <GeographyLetDown eligibilityLink={eligbilityCriteriaMessage} />,
            business_model_geo: (
              <BusinessModelGeoLetDown
                isMultiSelectBusinessModelFlow={isMultiSelectBusinessModelFlow}
                eligibilityLink={eligbilityCriteriaMessage}
              />
            ),
          }[data.ineligibleReason]
        : null}
      {backPath ? (
        <ButtonGroup
          secondaryAction={{
            onAction: () => navigate(backPath),
            content: intl.formatMessage(COMMON_MESSAGES.backLabel),
          }}
        />
      ) : null}
    </Flex>
  ) : null;
};
